import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Course } from 'lms-api';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-state-approval-alert',
  templateUrl: './state-approval-alert.component.html',
  styleUrls: ['./state-approval-alert.component.scss']
})
export class StateApprovalAlertComponent implements OnInit {
  @Input() course: Course;
  private courseApprovedStates: string[] = [];
  public userStates: string[] = [];
  public alertStates: string;

  constructor(public ucdService: UserCourseDataService) {
    this.ucdService.User.subscribe(user => {
      if (user.FullSSOData && user.FullSSOData.pac_lms && user.FullSSOData.pac_lms.approval_states) {
        this.userStates = user.FullSSOData.pac_lms.approval_states;
        this.CheckAlert();
      }
    });
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.course) {
      this.courseApprovedStates = changes.course.currentValue.approved_states.split(',');
      this.CheckAlert();
    }
  }

  private CheckAlert() {
    let unapprovedStates = [];
    this.userStates.forEach(state => {
      if (!this.courseApprovedStates.includes(state)) {
        unapprovedStates.push(state);
      }
    });
    this.alertStates = unapprovedStates.join(', ');
  }

  public ShowAlert(userStates: string[]): boolean {
    let memberApprovedStates = 0;

    return memberApprovedStates != userStates.length;
  }

}
